import React from "react"
import ReactEcharts from 'echarts-for-react';
import {Label} from 'semantic-ui-react'
import axios from 'axios'
import _ from 'lodash'
import {BlueMoon} from '../BlueMoon'
import { getTheme } from '../../config/clientConfig'

class Speedometer extends React.Component {

    constructor(props) {
        super(props);
        this.theme = getTheme();
        this.state = {
            expectedPercent: null, params: this.props.params
        }
    }

    getSpeedometerOption = (speedometerValue) => {
        var option = {
            backgroundColor: this.theme.backgrounds.panel,
            tooltip : {
            },

            toolbox: {
                show : true,
                feature : {

                }
            },

            series : [
                {
                    name:'Reach%',
                    type:'gauge',
                    data: [{value: 0}, {value: 0}],
                    min:0,
                    max:100,
                    animation: true,
                    animationDurationUpdate: 10000,
                    splitNumber: 10,
                    radius: '90%',
                    axisLine: {
                        lineStyle: {
                            color: this.theme.gauge.stages,
                            width: 15,
                            shadowColor : this.theme.gauge.shadow,
                            shadowBlur: 10
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            fontWeight: 'bolder',
                            color: this.theme.gauge.text,
                            shadowColor : this.theme.gauge.shadow,
                            shadowBlur: 10
                        }
                    },
                    axisTick: {
                        length :15,
                        lineStyle: {
                            color: 'auto',
                            shadowColor : this.theme.gauge.shadow,
                            shadowBlur: 10
                        }
                    },
                    splitLine: {
                        length :25,
                        lineStyle: {
                            width:3,
                            color: this.theme.gauge.text,
                            shadowColor : this.theme.gauge.shadow,
                            shadowBlur: 10
                        }
                    },
                    pointer: {
                        shadowColor : this.theme.gauge.shadow,
                        shadowBlur: 5,
                    },
                    title : {

                        textStyle: {
                            fontWeight: 'bolder',
                            fontSize: 20,
                            fontStyle: 'italic',
                            color: this.theme.gauge.text,
                            shadowColor : this.theme.gauge.shadow,
                            shadowBlur: 10
                        }
                    },
                    detail : {
                        show: false,
                        backgroundColor: this.theme.gauge.detail,
                        borderWidth: 1,
                        borderColor: this.theme.gauge.detail,
                        shadowColor : this.theme.gauge.detail,
                        shadowBlur: 5,
                        textStyle: {
                            fontWeight: 'bolder',
                            color: this.theme.gauge.detail
                        }
                    },

                    data:[{value: _.round(speedometerValue)}],


                }

            ]
        };
        return option;
    }

    fetchEvents = () => {
        axios.get(`${BlueMoon.ip}dashboard/speedometer`, {
            params: this.state.params
        }).then((response)=>{
           
           this.setState({ expectedPercent: response.data});
        })
    }

    componentWillReceiveProps = (nextProps, currentProps) => {
        // console.log("component will recieve in the speedometer is called");
        if (!_.isEqual(nextProps.params, this.state.params)) {
        this.setState({params: nextProps.params, expectedPercent: null}, () => {
            this.fetchEvents();
        })
        return true;
    }
    return true;
    }
    componentDidMount = () => {
        this.fetchEvents();
    }

    render() {
        if(_.isNull(this.state.expectedPercent)) return null;
        // console.log(this.state.expectedPercent)
        return (
            <div style = {{  borderRadius: '10px', backgroundColor: this.theme.backgrounds.page, marginTop: '1rem'}}>
        <Label as='a' ribbon color={'blue'} style={{ marginLeft: '1rem'}} size={'large'}>{"Expected Reach"}</Label>

            <ReactEcharts
            
                option={this.getSpeedometerOption(this.state.expectedPercent*100)}
                notMerge={true}
                style={{height: '240px', width: '100%'}}
                lazyUpdate={false}
                theme={"dark"} />
                </div>
        )
    }

}

export default Speedometer;